// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-2fdbb2de] .inline {\n  max-width: 200px;\n  height: 38px;\n}", ""]);
// Exports
module.exports = exports;
